import React from "react";
import { Squares2X2Icon } from "@heroicons/react/24/outline";

const ListingHeaderSkeleton = () => {
  return (
    <header className="rounded-md sm:rounded-xl animate-pulse">
      <div className="relative grid grid-cols-4 gap-1 sm:gap-2">
        {/* Main image skeleton */}
        <div className="col-span-3 row-span-3 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer bg-neutral-200 h-60 sm:h-80">
          <div className="absolute inset-0 bg-neutral-300 rounded-md sm:rounded-xl" />
          <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity" />
        </div>

        {/* Secondary image skeletons */}
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className={`relative rounded-md sm:rounded-xl overflow-hidden bg-neutral-200 h-28 sm:h-40 ${
              index >= 2 ? "hidden sm:block" : ""
            }`}
          >
            <div className="absolute inset-0 bg-neutral-300 rounded-md sm:rounded-xl" />
            <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity" />
          </div>
        ))}


      </div>
    </header>
  );
};

export default ListingHeaderSkeleton;